var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyMemberPerformance = function SvgImgEmptyMemberPerformance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_14853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 15H14C11.2386 15 9 17.2386 9 20V58C9 60.7614 11.2386 63 14 63H66C68.7614 63 71 60.7614 71 58V20C71 17.2386 68.7614 15 66 15Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28H14.5C13.6716 28 13 28.6716 13 29.5C13 30.3284 13.6716 31 14.5 31H28.5C29.3284 31 30 30.3284 30 29.5C30 28.6716 29.3284 28 28.5 28Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 42H14.5C13.6716 42 13 42.6716 13 43.5C13 44.3284 13.6716 45 14.5 45H18.5C19.3284 45 20 44.3284 20 43.5C20 42.6716 19.3284 42 18.5 42Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 42H23.5C22.6716 42 22 42.6716 22 43.5C22 44.3284 22.6716 45 23.5 45H35.5C36.3284 45 37 44.3284 37 43.5C37 42.6716 36.3284 42 35.5 42Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 35H14.5C13.6716 35 13 35.6716 13 36.5C13 37.3284 13.6716 38 14.5 38H55.5C56.3284 38 57 37.3284 57 36.5C57 35.6716 56.3284 35 55.5 35Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 49H14.5C13.6716 49 13 49.6716 13 50.5C13 51.3284 13.6716 52 14.5 52H46.5C47.3284 52 48 51.3284 48 50.5C48 49.6716 47.3284 49 46.5 49Z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22.5H70.5",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7903 42H39.2097C38.5416 42 38 42.4197 38 42.9375V50.0625C38 50.5803 38.5416 51 39.2097 51H51.7903C52.4584 51 53 50.5803 53 50.0625V42.9375C53 42.4197 52.4584 42 51.7903 42Z",
    fill: "#F9F9F9",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7742 45H38.2258C36.4442 45 35 46.3058 35 47.9167V70.0833C35 71.6942 36.4442 73 38.2258 73H71.7742C73.5558 73 75 71.6942 75 70.0833V47.9167C75 46.3058 73.5558 45 71.7742 45Z",
    fill: "#EBEBEB",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.984 63.5441C41.0102 63.517 41.0277 63.5049 41.0364 63.5H68.9636C68.9723 63.5049 68.9898 63.517 69.016 63.5441C69.0795 63.6097 69.1597 63.7309 69.2377 63.9215C69.3926 64.3004 69.5 64.8582 69.5 65.5C69.5 66.1418 69.3926 66.6996 69.2377 67.0785C69.1597 67.2691 69.0795 67.3903 69.016 67.4559C68.9898 67.483 68.9723 67.4951 68.9636 67.5H41.0364C41.0277 67.4951 41.0102 67.483 40.984 67.4559C40.9205 67.3903 40.8403 67.2691 40.7623 67.0785C40.6074 66.6996 40.5 66.1418 40.5 65.5C40.5 64.8582 40.6074 64.3004 40.7623 63.9215C40.8403 63.7309 40.9205 63.6097 40.984 63.5441ZM68.9572 63.497C68.9572 63.4969 68.9581 63.4972 68.9598 63.498C68.9581 63.4975 68.9572 63.4971 68.9572 63.497ZM68.9572 67.503C68.9572 67.5029 68.9581 67.5025 68.9598 67.502C68.9581 67.5028 68.9572 67.5031 68.9572 67.503ZM41.0428 67.503C41.0428 67.5031 41.0419 67.5028 41.0402 67.502C41.0419 67.5025 41.0428 67.5029 41.0428 67.503ZM41.0402 63.498C41.0419 63.4972 41.0428 63.4969 41.0428 63.497C41.0428 63.4971 41.0419 63.4975 41.0402 63.498Z",
    fill: "white",
    stroke: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_14853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyMemberPerformance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_empty_memberPerformance.cae30c6eb200617d0d72bc2f11855553.svg";